var path = '/app/pages/account/activity/account.activity.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/activity/account.activity.html
// module id = 1129
// module chunks = 0